module.exports = __webpack_public_path__ + "img/scholarship3.c8576312.png";